module.exports = __webpack_public_path__ + "img/bg3.19ed590e.jpg";